'use client'

import { useTranslations } from 'next-intl'
import { tw } from 'utils/classnames'

import { ProductBuyButton } from '../buy'

export function DownloadOverlay() {
  const t = useTranslations('prod.product_description_page.buy')

  return (
    <div
      className={tw(
        'absolute inset-0 z-10',
        'flex flex-col items-center justify-center gap-2',
        'bg-[#272B2F]/60',
        'opacity-0 transition-opacity duration-300 group-hover:opacity-100',
        'pointer-events-none group-hover:pointer-events-auto',
      )}
    >
      <p className="font-poppins text-[28px] font-bold text-cf-white uppercase">
        {t('overlay_title')}
      </p>
      <ProductBuyButton className="bg-secondary-500 hover:bg-secondary-700" />
    </div>
  )
}
